<div toastContainer></div>

<div *ngIf="browsing" class="app-browsing no-select">
	<div *ngIf="browsing" class="indeterminate"></div>
</div>

<div *ngIf="progress" class="app-progress no-select"
[style.width]="progress + '%'">
</div>

<div class="app-header">
  <header></header>
  <navbar></navbar>
</div>

<div class="app-content" #mainFrame id="agree-main">
  <router-outlet></router-outlet>
</div>

<!-- <ng-template #modal>
  <div class="modal-body text-center">
    <i class="material-symbols-rounded faded text-muted" style="font-size: 800%;">campaign</i>
    <h3>Nuestro dominio es: <b>agree.ag</b></h3>
    <p><code>agreemarket.com</code> redirigirá automáticamente a partir del <b>1 de Febrero de 2024</b>.</p>
    <p class="small text-muted">Por favor, actualice sus marcadores.</p>
  </div>
  <div class="modal-footer">
    <a class="btn btn-lg btn-agree btn-block" href="{{ document.location.href.replace('agreemarket.com', 'agree.ag') }}">
      Continuar al sitio
    </a>
  </div>
</ng-template> -->

<ng-template #modalRebrand>
  <div class="modal-header">
    <h4 class="modal-title">¡Agree ahora es Agrology!</h4>
  </div>
  <div class="modal-body">
    <p>Estimado usuario,</p>
    <p>Queremos compartir con vos una novedad importante: <strong>Agree se integra oficialmente a Agrology</strong>. Como parte de este crecimiento, estamos renovando nuestra identidad visual para reflejar nuestra unión.</p>
    <h5>¿Qué cambia hoy?</h5>
    <ul>
      <li><strong>Nueva Imagen:</strong> Verás nuestro nuevo logo y una paleta de colores renovada.</li>
      <li><strong>Nueva URL:</strong> Muy pronto la dirección de acceso cambiará a una de Agrology, pero si ingresás a la antigua, te redirigiremos automáticamente.</li>
    </ul>
    <h5>¿Qué se mantiene igual?</h5>
    <ul>
      <li><strong>Mismas Credenciales:</strong> No tenés que crear una cuenta nueva ni cambiar tu contraseña.</li>
      <li><strong>Estructura y Funcionalidad:</strong> La plataforma que ya conocés sigue funcionando exactamente igual.</li>
      <li><strong>Tu Operatividad:</strong> Todo el historial y la información de tu cuenta están seguros y disponibles.</li>
    </ul>
    <p>¿Tenés alguna duda o inconveniente para ingresar?<br>
    Escribinos directamente a: <strong>📧 contacto&#64;agrology.com</strong></p>
    <p>Gracias por seguir confiando en nosotros. <strong>¡Bienvenidos a la nueva era de Agrology!</strong></p>
  </div>
  <div class="modal-footer">
    <button class="btn btn-lg btn-agree btn-block" (click)="dismissRebrandModal()">
      Entendido
    </button>
  </div>
</ng-template>

<ng-template #modalUpdate>
  <!-- modal -->
  <div class="modal-body text-center">
    <i class="material-symbols-rounded faded text-muted" style="font-size: 800%;">release_alert</i>
    <h3>Nueva versión disponible!</h3>
    <p>Para aplicar todas las novedades es necesario <b>recargar la aplicación</b>.</p>
  </div>
  <div class="modal-footer">
    <a class="btn btn-lg btn-agree btn-block" (click)="refresh()">
      <span class="material-symbols-rounded">refresh</span>
      Recargar la aplicación
    </a>
  </div>
</ng-template>